import { Component, h, State } from '@stencil/core';
import { getAuthClient, AuthClientInstance } from '@trumpf/ux.utils';

@Component({
  tag: 'my-component',
  styleUrl: 'my-component.css',
  shadow: true,
})
export class MyComponent {
  @State() token: string | null = null;

  private authClient: AuthClientInstance;

  constructor() {
    this.authClient = getAuthClient(); // Initialize the auth client
  }

  componentDidLoad() {
    this.retrieveToken(); // Call to dynamically retrieve the token after the component loads
  }

  private async retrieveToken() {
    try {
      let token = this.authClient.getAccessToken();

      if (!token) {
        console.warn('Token is not available yet. Waiting for initialization...');
        token = await this.waitForToken();
      }

      if (token) {
        console.log('Access Token:', token);
        this.token = token;
        sessionStorage.setItem('auth_token', token);
      } else {
        console.warn('Token is still unavailable after waiting.');
      }
    } catch (error) {
      console.error('Error retrieving access token:', error);
    }
  }

  private async waitForToken(maxRetries = 10, delayMs = 200): Promise<string | null> {
    for (let attempt = 0; attempt < maxRetries; attempt++) {
      const token = this.authClient.getAccessToken();
      if (token) {
        return token;
      }
      await new Promise(resolve => setTimeout(resolve, delayMs)); // Delay before next attempt
    }
    return null;
  }

  render() {
    return (
      <div>
        <ux-u-silent-auth client-id="1kffflasH4444COTiFmP8DDO9ywa"></ux-u-silent-auth>
      </div>
    );
  }
}
